/**
 * Collection credit review request permissions — capability keys (Slice C).
 */

export const COLLECTION_CREDIT_REVIEW_READ_PERMISSION = 'collection_credit_review:read' as const;
export const COLLECTION_CREDIT_REVIEW_CLAIM_PERMISSION = 'collection_credit_review:claim' as const;
export const COLLECTION_CREDIT_REVIEW_DEFER_PERMISSION = 'collection_credit_review:defer' as const;
export const COLLECTION_CREDIT_REVIEW_RESOLVE_PERMISSION =
  'collection_credit_review:resolve' as const;
export const COLLECTION_CREDIT_REVIEW_CANCEL_PERMISSION =
  'collection_credit_review:cancel' as const;

export const COLLECTION_CREDIT_REVIEW_PERMISSIONS = [
  COLLECTION_CREDIT_REVIEW_READ_PERMISSION,
  COLLECTION_CREDIT_REVIEW_CLAIM_PERMISSION,
  COLLECTION_CREDIT_REVIEW_DEFER_PERMISSION,
  COLLECTION_CREDIT_REVIEW_RESOLVE_PERMISSION,
  COLLECTION_CREDIT_REVIEW_CANCEL_PERMISSION,
] as const;

export type CollectionCreditReviewPermission =
  (typeof COLLECTION_CREDIT_REVIEW_PERMISSIONS)[number];

export function isCollectionCreditReviewPermission(
  value: string
): value is CollectionCreditReviewPermission {
  return (COLLECTION_CREDIT_REVIEW_PERMISSIONS as readonly string[]).includes(value);
}
